<template>
  <div class="dms-view">
    <MdtNotify />
    <MdtLightbox />
    <UnprotectedViewHeader />
    <div class="dms-view-content">
      <RouterView class="dms-view-router" />
    </div>
    <UnprotectedViewFooter />
  </div>
</template>

<script>
import UnprotectedViewHeader from '@/components/unprotected-view/UnprotectedViewHeader.vue';
import UnprotectedViewFooter from '@/components/unprotected-view/UnprotectedViewFooter.vue';
import MdtLightbox from '@/components/shared/MdtLightbox.vue';

export default {
  name: 'DmsView',
  components: {
    UnprotectedViewHeader,
    UnprotectedViewFooter,
    MdtLightbox,
  },
};
</script>

<style lang="scss" scoped>
.dms-view {
  padding: 0 $unprotected-view-padding;
  background-color: $color-back-light;

  @media only screen and (max-width: 576px) {
    padding: 0 $unprotected-view-padding-small;
  }

  .dms-view-content {
    width: 100%;
    max-width: $unprotected-view-max-width;
    min-height: calc(100vh - #{$login-header-height} - #{$login-footer-height});
    margin: 0 auto;
    color: $color-text-primary;

    .dms-view-router {
      width: 100%;
      min-height: calc(100vh - #{$login-header-height} - #{$login-footer-height});
      padding: $unprotected-view-padding 0;

      @media only screen and (max-width: 576px) {
        padding: $unprotected-view-padding-small 0;
      }
    }
  }
}
</style>
